<mat-toolbar class="primary">
  <span class="contact-icon"><i class="fa-solid fa-id-badge"></i></span>
  {{'ASTIMAX.CONTACT.WIDGET.CREATE_MANUAL_CONTACT' | translate }}
  <span class="adx-toolbar-spacer"></span>
  <button mat-icon-button
    [mat-dialog-close]="false"
    aria-label="Close Button"
    matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CLOSE' | translate }}">
    <fa-icon [icon]="'xmark'"></fa-icon>
  </button>
</mat-toolbar>

<mat-dialog-content class="adx-dialog-content-wrapper">
  <form #contactForm="ngForm" novalidate>
    <!-- Name Field -->
    <mat-form-field appearance="outline" class="adx-full-width">
      <mat-label>{{'ASTIMAX.CONTACT.WIDGET.NAME' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="contactName"
        name="contactName"
        #nameInput="ngModel"
        placeholder="{{'ASTIMAX.CONTACT.WIDGET.NAME' | translate }}"
        aria-label="Contact name"
        maxlength="100"
        required
        minlength="2"
        type="text"
        autocomplete="name">
        @if (nameInput.invalid && nameInput.touched) {
          <mat-error>
            @if (nameInput.errors?.['required']) {
              <span>{{'ASTIMAX.CONTACT.WIDGET.NAME_REQUIRED' | translate }}</span>
            }
            @if (nameInput.errors?.['minlength']) {
              <span>{{'ASTIMAX.CONTACT.WIDGET.NAME_MIN_LENGTH' | translate }}</span>
            }
          </mat-error>
        }
      </mat-form-field>

      <!-- Phone Number Field -->
      <mat-form-field appearance="outline" class="adx-full-width">
        <mat-label>{{'ASTIMAX.CONTACT.WIDGET.PHONE_NUMBER' | translate }}</mat-label>
        <input
          matInput
          [(ngModel)]="phoneNumber"
          name="phoneNumber"
          #phoneInput="ngModel"
          placeholder="{{'ASTIMAX.CONTACT.WIDGET.PHONE_NUMBER' | translate }}"
          aria-label="Phone number"
          maxlength="50"
          required
          type="tel"
          autocomplete="tel">
          @if (phoneInput.invalid && phoneInput.touched) {
            <mat-error>
              @if (phoneInput.errors?.['required']) {
                <span>{{'ASTIMAX.CONTACT.WIDGET.PHONE_REQUIRED' | translate }}</span>
              }
            </mat-error>
          }
        </mat-form-field>

        <!-- Info Section -->
        <div class="adx-info-section">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
          <div class="adx-info-content">
            <p>{{'ASTIMAX.CONTACT.WIDGET.MANUAL_CONTACT_INFO' | translate }}</p>
          </div>
        </div>
      </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button
        mat-raised-button
        (click)="onCancel()"
        type="button"
        aria-label="Cancel creation"
        matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CANCEL' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.CANCEL' | translate }}
      </button>
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!isFormValid()"
        [attr.aria-label]="isFormValid() ? 'Create manual contact' : 'Cannot create - form invalid'"
        matTooltip="{{'ASTIMAX.CONTACT.WIDGET.CREATE_MANUAL_CONTACT' | translate }}">
        {{'ASTIMAX.CONTACT.WIDGET.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
